import { EntityBase } from '@/bases';

export class NotificationTemplate extends EntityBase {
  private _ModifiedOn: Date = null;

  public get NotificationTemplateId(): string { return this.Id; }
  public set NotificationTemplateId(value: string) { this.Id = value; }

  public NotificationType: number = null;
  public CommunicationType: number = null;
  public Branding: number = null;
  public Sender: string = null;
  public Subject: string = null;
  public Body: string = null;
  public get ModifiedOn(): Date { return this._ModifiedOn; }
  public set ModifiedOn(value: Date) { this._ModifiedOn = value === null || value instanceof Date ? value : new Date(value); }
  public ModifiedBy: string = null;

  constructor(data: any = null) {
    super();
    this.Assign(data);
  }

  public toJSON(): any {
    return {
      NotificationTemplateId: this.NotificationTemplateId,
      NotificationType: this.NotificationType,
      CommunicationType: this.CommunicationType,
      Branding: this.Branding,
      Sender: this.Sender,
      Subject: this.Subject,
      Body: this.Body,
      ModifiedOn: this.ModifiedOn,
      ModifiedBy: this.ModifiedBy
    };
  }
}

export enum NotificationTemplateCommunicationType {
  Email = 1,
  SMS = 2
}

export enum NotificationTemplateNotificationType {
  UnconfirmedAppointmentNotification1 = 1,
  UnconfirmedAppointmentNotification2 = 2,
  AppointmentReminder1 = 3,
  AppointmentReminder2 = 4,
  AppointmentConfirmed = 5,
  ConfirmedAppointmentNotification1 = 6,
  ConfirmedAppointmentNotification2 = 7,
  UnscheduledAppointmentNotification1 = 8,
  UnscheduledAppointmentNotification2 = 9,
  UnconfirmedAppointmentNotification3 = 10,
  AGradePressureItemUnconfirmedAppointmentNotification1 = 11,
  AGradePressureItemUnconfirmedAppointmentNotification2 = 12,
  AGradePressureItemAppointmentReminder1 = 13,
  AGradePressureItemAppointmentReminder2 = 14,
  AGradePressureItemAppointmentConfirmed = 15,
  AGradePressureItemConfirmedAppointmentNotification1 = 16,
  AGradePressureItemConfirmedAppointmentNotification2 = 17,
  AGradePressureItemUnscheduledAppointmentNotification1 = 18,
  AGradePressureItemUnscheduledAppointmentNotification2 = 19,
  AGradePressureItemUnconfirmedAppointmentNotification3 = 20
}